import React, { useCallback, useState } from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { toCategoryUI } from '../../mappers/categories/toCategoryUI';
import { UserSettings as UserSettingsUI } from '../../ui/users/UserSettings';
import { useCategoriesController } from '../categories/useCategoriesController';
import { withAuthProtection } from '../withAuthProtection';
import type { CategoryModel } from '../../data-layer/categories/types';

const NAMESPACE = 'userSettings';

export const UserSettings = withAuthProtection(() => {
    const categoriesController = useCategoriesController(NAMESPACE);
    const [selectedCategories, setSelectedCategories] = useState<Array<CategoryModel['id']>>([]);
    const onSave = useCallback(() => {
        // TODO: Добавить сохранение категорий
    }, []);

    useEffectOnce(() => {
        if (!categoriesController.isLoading) {
            categoriesController.onLoad();
        }
    });

    return (
        <UserSettingsUI
            categories={categoriesController.items.map(toCategoryUI)}
            selectedCategories={selectedCategories}
            onCategoriesChange={setSelectedCategories}
            onSave={onSave}
        />
    );
});
